export default __webpack_public_path__ + "static/media/certifiedJava.8ce2b12e.png";